// extracted by mini-css-extract-plugin
module.exports = {"submitted":"L17_submitted__3JsUE"};